import { useNavigate } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import { useTranslation } from 'react-i18next';
import Modal from 'shared/ui/modal';
import { BookOpenIcon } from 'shared/ui/icons';
import {
  resetUploadState,
  setProgressModalOpen,
} from 'store/buku-tarif/bukuTarifSlice';

const ModalProgressUpload = ({ isOpen, onClose }) => {
  const { t } = useTranslation('common');
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const handleBack = () => {
    dispatch(setProgressModalOpen(false));
    dispatch(resetUploadState());
    onClose();
    navigate('/buku-tarif');
  };

  return (
    <Modal title="" isOpen={isOpen} setIsOpen={() => onClose()} footer={false}>
      <div className="w-[400px]">
        <div className="w-full flex flex-col gap-2 justify-center items-center py-4">
          <div className="w-auto border border-yellow-500 rounded-lg p-3 bg-yellow-50">
            <BookOpenIcon color="#ca8a04" width="22" />
          </div>
          <p className="text-gray-700 text-xl font-semibold text-center">
            {t('tariff_book_processing')}
          </p>
          <p className="text-center">
            {t('tariff_book_processing_description')}
          </p>
          <button
            type="button"
            className="text-blue-500 cursor-pointer"
            onClick={handleBack}
          >
            {t('back_to_tariff_book_list')}
          </button>
        </div>
      </div>
    </Modal>
  );
};

export default ModalProgressUpload;
